// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  production: false,
  subscriberId: "in-app-sandbox-subscriber-id-123",
  applicationIdentifier: "447wVutpxxvV",
  baseUrl: '',
  EncryptKey: '1203199320052021',
  EncryptIV: '1203199320052021',
  recaptchaSiteKey: '',
  // Task #55: Google/Microsoft OAuth login. Same "off until configured" posture as recaptchaSiteKey
  // above — Login.ts only initializes the Google Identity Services / MSAL SDKs and renders a
  // sign-in button when the matching client id is non-blank, and the backend's
  // OAuth:Google:Enabled/OAuth:Microsoft:Enabled independently default to false (GoogleOAuthVerifier/
  // MicrosoftOAuthVerifier short-circuit to "not configured"), so leaving these blank is always safe.
  // Set the frontend AND backend values together once you have real app registrations.
  googleOAuthClientId: '',
  microsoftOAuthClientId: '',
  // Azure AD authority — 'common' allows both personal and work/school Microsoft accounts; replace
  // with 'https://login.microsoftonline.com/<your-tenant-id>' to restrict to a single org, matching
  // OAuth:Microsoft:TenantId server-side (see MicrosoftOAuthOptions remarks for why the backend
  // doesn't enforce this itself today).
  microsoftOAuthAuthority: 'https://login.microsoftonline.com/common',

  firebase: {
    apiKey: 'AIzaSyCSG-EGU2RLITgpjf_ogf1w47edC_DXlWc',
    authDomain: 'evolvision-rnd.firebaseapp.com',
    databaseURL: 'https://evolvision-rnd.firebaseio.com',
    projectId: 'evolvision-rnd',
    storageBucket: 'evolvision-rnd.appspot.com',
    messagingSenderId: '890895206035',
    appId: '1:890895206035:web:a6d0e1574d59ffe40bef66'
  },
  googleApiKey: 'AIzaSyAIIYOxA7qeetFz6TuR1Qewc0Rrjhzx7ZU',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
